import { useState } from "react";
import { Link } from "react-router-dom";
import { api, errMsg } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { MailCheck } from "lucide-react";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await api.post("/auth/forgot-password", { email, origin_url: window.location.origin });
      setSent(true);
    } catch (e2) {
      setError(errMsg(e2));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div data-testid="forgot-password-page" className="max-w-md mx-auto px-6 pt-40 pb-24">
      <img src="/logo.png" alt="Easy Drive Car Rental" className="h-20 w-auto object-contain mb-6" />
      <p className="text-[11px] font-ui tracking-[0.3em] uppercase text-primary">Account recovery</p>
      <h1 className="mt-3 font-display text-4xl sm:text-5xl tracking-tight">
        Forgot your <span className="italic gold-text">password?</span>
      </h1>
      {sent ? (
        <div data-testid="forgot-success-panel" className="mt-10 bg-card border border-border rounded-2xl p-8 text-center">
          <MailCheck size={28} className="gold-text mx-auto" />
          <p className="mt-4 font-ui text-sm leading-relaxed text-muted-foreground">
            If an account exists for <span className="text-foreground font-semibold">{email}</span>,
            a password reset link is on its way. It expires in 1 hour.
          </p>
          <Link to="/login">
            <Button data-testid="forgot-back-login-button" variant="outline" className="mt-6 rounded-full border-border bg-transparent hover:bg-black/5 hover:text-primary font-ui">
              Back to Sign In
            </Button>
          </Link>
        </div>
      ) : (
        <form onSubmit={submit} className="mt-10 space-y-6">
          <div>
            <Label className="font-ui text-xs tracking-wide text-muted-foreground">Account email</Label>
            <Input data-testid="forgot-email-input" type="email" required value={email} onChange={(e) => setEmail(e.target.value)} placeholder="you@email.com" className="input-dark mt-2" />
          </div>
          {error && <p data-testid="forgot-error" className="text-sm text-destructive font-ui">{error}</p>}
          <Button data-testid="forgot-submit-button" disabled={loading} className="w-full rounded-full bg-primary text-primary-foreground hover:bg-primary/90 font-ui h-11">
            {loading ? "Sending…" : "Send Reset Link"}
          </Button>
          <p className="text-sm text-muted-foreground font-ui text-center">
            Remembered it? <Link data-testid="forgot-login-link" to="/login" className="gold-text hover:underline">Sign in</Link>
          </p>
        </form>
      )}
    </div>
  );
}
